import React from 'react';
import PropTypes from 'prop-types';
import LikeItem from './likeItem';

const LikesList = (props) => {
  const listItems = props.likes.map(like => {
    return <LikeItem key={like.id} like={like} />;
  });

  return (
    <ol>
      {listItems}
    </ol>
  );
}

LikesList.propTypes = {
  likes: PropTypes.array.isRequired
};

export default LikesList;


// WEBPACK FOOTER //
// ./src/views/likesList.js